import React from 'react';
import PropTypes from 'prop-types';
import {Img, Container} from './styles';

import closeIcon from 'assets/img/close.svg';

const CloseNotification = ({closeToast}) => (
  <Container>
    <Img src={closeIcon} onClick={closeToast} />
  </Container>
);

CloseNotification.propTypes = {
  closeToast: PropTypes.func,
};

export default CloseNotification;
